import { render, staticRenderFns } from "./header-menu.vue?vue&type=template&id=77843422"
import script from "./header-menu.vue?vue&type=script&lang=js"
export * from "./header-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports